export const TERMINALS = 'TERMINALS';
export const SELCTED_TERMINAL = 'SELCTED_TERMINAL';
export const APP_TERMINAL_BUSY = 'APP_TERMINAL_BUSY';
